import { Injectable } from '@angular/core';
import { BehaviorSubject, map } from 'rxjs';
import { NxLicenseService } from '../api/services/nx-license.service';
import { LicenseResponse } from '../api/models/license-response';

interface LicenseState {
  data: LicenseResponse | null;
  headerStatus: string | undefined;
  loading: boolean;
}

@Injectable({ providedIn: 'root' })
export class LicenseStateService {
  private state = new BehaviorSubject<LicenseState>({
    data: null,
    headerStatus: undefined,
    loading: false,
  });

  state$ = this.state.asObservable();
  data$ = this.state$.pipe(map(s => s.data));
  headerStatus$ = this.state$.pipe(map(s => s.headerStatus));
  isLoading$ = this.state$.pipe(map(s => s.loading));
  status$ = this.state$.pipe(map(s => s.data?.status ?? s.headerStatus));

  constructor(private nxLicenseService: NxLicenseService) {}

  setHeaderStatus(status: string | undefined) {
    this.state.next({ ...this.state.value, headerStatus: status });
  }

  loadLicense() {
    this.state.next({ ...this.state.value, loading: true });
    this.nxLicenseService.nxLicenseControllerGetLicenseData().subscribe({
      next: res => {
        this.state.next({
          data: res.data ?? null,
          headerStatus: this.state.value.headerStatus,
          loading: false,
        });
      },
      error: () => {
        this.state.next({ ...this.state.value, loading: false });
      },
    });
  }

  get currentHeaderStatus(): string | undefined {
    return this.state.value.headerStatus;
  }

  get currentData(): LicenseResponse | null {
    return this.state.value.data;
  }
}
